/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-06 16:19:29
 * @LastEditors: wangjianfeng
 * @LastEditTime: 2022-10-09 15:34:17
 * @FilePath: \CoreWeb\packages\Api\sysdata-api\src\ShareinstancetoinstitutionApi.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { SysDataBaseApi } from "./SysDataBaseApi";

/**
 * 线路共享给系统项目Api
 * 单位工程共享给线路Api
 * 线路共享给机构Api
 * 单位工程共享给机构Api
 */
export class ShareinstancetoinstitutionApi extends SysDataBaseApi {
    public get ControllerName(): any {
        return 'Shareinstancetoinstitution'
    }
    /**
     * 系统项目分配线路
     * @param SysId
     * @param Robject
     */
    public configRoadForProjectSystem(SysId: number, Robject: Array<any>) {
        return this.send({ SysId: SysId, Robject: Robject }, 'SetShareRelationOfRoadToProjectSystem', this.Methods.POST)
    }
    public QueryRoadForProjectSystem(SysId: number) {
        return this.send({ SysId: SysId }, "GetShareRelationOfRoadToProjectSystem", this.Methods.GET);
    }
    /**
     * 组织架构分配线路
     * @param BIId
     * @param Robject
     */
    public configRoadForBInstitution(BIId: number, Robject: Array<any>) {
        return this.send({ BIId: BIId, Robject: Robject }, 'SetShareRelationOfRoadToBInstitution', this.Methods.POST)
    }
    public QueryRoadForBInstitution(BIId: number) {
        return this.send({ BIId: BIId }, "GetShareRelationOfRoadToBInstitution", this.Methods.GET);
    }

    /**
    * 根据机构获取单位工程
    * @param BIId
    */
    public GetDatastructure(BIId: number) {
        return this.send({ BIId: BIId }, "GetDatastructure", this.Methods.GET);
    }

    /**
     * 组织架构分配线路单位工程
     * @param BIId
     * @param Robject
     */Instance
    public configRoadInstanceForBInstitution(BIId: number, RId: number, StypeId: number, Robject: Array<any>) {
        return this.send({ BIId: BIId, RId: RId, StypeId: StypeId, Robject: Robject }, 'SetShareRelationOfRoadInstancesToBInstitution', this.Methods.POST)
    }
    public QueryRoadInstanceForBInstitution(BIId: number, RId: number,) {
        return this.send({ BIId: BIId, RId: RId }, "GetShareRelationOfRoadInstancesToBInstitution", this.Methods.GET);
    }
    /**
     * 根据当前登录机构获取线路
     * @param BIId 业务机构Id
     * @param RoadId 线路Id
     */
    public GetShareRoadInfoByBIId(BIId: any, RoadId: any = 0) {
        return this.send({ BIId: BIId }, "GetShareRoadInfoByBIId", this.Methods.GET);
    }

    /**
    * 根据线路获取合同段
    * @param RoadId 线路Id
    */
    public GetShareInstitutionByRoadId(projectId: any, RoadId: any, subSysId: any) {
        return this.send({ projectId: projectId, RoadId: RoadId, subSysId: subSysId }, "GetShareInstitutionByRoadId", this.Methods.GET);
    }
    /**移除配置关系 
     * @param BIId 
     * @param RId 
     * @returns 
     */
    public ReleaseRoadAndInstitution(BIId: number, RId: Number) {
        return this.send({ BIId, RId }, "ReleaseRoadAndInstitution", this.Methods.GET);
    }

    public GetShareRelationOfBridgeInfor(pageIndex, pageSize, param) {
        return this.send({ pageIndex: pageIndex, pageSize: pageSize, param: param }, 'GetShareRelationOfBridgeInfor', this.Methods.GET)
    }
    /**
     * 根据当前线路获取机构Id
     * @param RoadId 线路Id
     */
    public GetShareBIIdByRoadId(RoadId: any) {
        return this.send({ RoadId: RoadId }, "GetShareBIIdByRoadId", this.Methods.GET);
    }

    /**
    * 根据机构获取配置的单位工程
    * @param BIId
    */
    public GetShareDataInstitutionByBIId(obj: any) {
        return this.send(obj, "GetShareDataInstitutionByBIId", this.Methods.POST);
    }
    
}